import queryString from 'query-string';

import * as components from '../components';

/* global jQuery */

export default class App {
  init() {
    this.selectActiveTab();
    this.initComponents();
  }

  selectActiveTab() {
    const query = queryString.parseUrl(window.location.href).query;

    if (query.target) {
      // find target node that needs to be clicked
      const node =
        document.querySelector(`a[href="#${query.target}"]`) ||
        document.getElementById(query.target);

      // if a node was found
      if (node) {
        // dispatch a virtual click event on it so that tab gets selected
        jQuery(node).trigger('click');
      }
    }
  }

  initComponents() {
    // loop each registered component
    const componentNames = Object.keys(components);

    componentNames.forEach(componentName => {
      // get nodes by defined selector
      const Component = components[componentName];
      const nodesToInstantiate = [...document.querySelectorAll(Component.selectorString())];

      // instantiate the js class for each node
      nodesToInstantiate.forEach(node => {
        const props = node.getAttribute('data-props');
        const parsedProps = props && props.length > 0 ? JSON.parse(props) : {};
        const attributes = [...node.attributes].reduce((result, attr) => {
          if (attr.name.indexOf('data-') === 0 && attr.name !== 'data-props') {
            return {
              ...result,
              [attr.name.substring(5)]: attr.value,
            };
          }

          return result;
        }, {});

        const data = {
          ...attributes,
          ...parsedProps,
        };

        const component = new Component();
        node.component = component;
        component.node = node;
        component.props = data;
        if (component.render) {
          component.render(node, data);
        }
      });
    });
  }
}
